import { Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { presentFormatedData } from '../functionalComponents/dataFormatFunctions';
import { useDispatch } from 'react-redux';
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from '../../../containers/actions/types';
import { appUrl } from '../../../../../utils/config';
import axios from 'axios';
import FileViewer from '../supplierPOCoAFileViewer/FileViewer';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },

  font: {
    fontWeight: 500,
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
  },
  fontPadding: {
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
    overflow: 'auto',
  },
  button: {
    backgroundColor: 'transparent',
    textAlign: 'end',
    paddingTop: '1rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  files: {
    boder: '1px solid #707070',
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
    padding: '2rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  closeText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline',
  },
  document: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const ASNDetails = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openFileView, setOpenFileView] = useState(false);
  // const [coaName, setCoAName] = useState('CertificateOfAnalysis');
  const [coaId, setCoAId] = useState(null);

  const {
    asnDetails,
    challanInformation,
    POBatchRecordDetails,
    invoiceInformation,
  } = props;

  const handleDownload = (Id) => {
    if (Id) {
      let backdropText = 'Downloading, Please Wait...';
      dispatch({
        type: OPEN_BACKDROP,
        backdropText,
      });
      // axios
      //   .get(
      //     `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/getCOADetails/download/${Id}`
      //   )
      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadGRFiles`,
          { schrockenGRFileId: Id }
        )
        .then((res) => {
          if (res.data.status) {
            let fileDataArray = res.data.fileData.data;
            var byteArray = new Uint8Array(fileDataArray);

            var a = window.document.createElement('a');

            a.href = window.URL.createObjectURL(
              new Blob([byteArray], { type: 'application/octet-stream' })
            );
            a.download = res.data.fileName;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
          dispatch({
            type: DESTROY_BACKDROP,
          });
        })
        .catch((err) => {
          console.log(err);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        });
    }
  };

  // useEffect(() => {
  //   const Id = asnDetails?.coaDocumentID;
  //   if (Id) {
  //     axios
  //       .get(
  //         `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/getCOADetails/download/${Id}`
  //       )
  //       .then((res) => {
  //         if (res.data.status) {
  //           setCoAName(res.data.fileName);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // }, []);

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            ASN Details
          </Typography>
          <span className={classes.borders}></span>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            ASN Number
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(asnDetails?.asnNumber, 'NA')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            ASN Document Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {asnDetails?.asnLastModifiedDate
              ? presentFormatedData(
                  new Date(asnDetails.asnLastModifiedDate.split('T')[0])
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            ASN Schedule Delivery Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {asnDetails?.asnDeliveryDate
              ? presentFormatedData(
                  new Date(asnDetails?.asnDeliveryDate.split('T')[0])
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>

        {/* Row 2 — 2 columns aligned under first two columns */}
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            E-way Bill No.
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(challanInformation?.ewayBillNumber, 'NA')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            E-way Bill Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {challanInformation?.ewayBillDate
              ? presentFormatedData(
                  new Date(challanInformation?.ewayBillDate.split('T')[0])
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}></Grid>

        {/* Row 3 — 2 columns */}
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            BoE No.
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(asnDetails?.asnBoENO, 'NA')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            BoE Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {asnDetails?.asnBoEIDDate
              ? presentFormatedData(
                  new Date(asnDetails.asnBoEIDDate.split('T')[0])
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}></Grid>

        {/* Editable Fields (conditional) */}
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Lorry Receipt (LR) Number
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(
              POBatchRecordDetails?.lorryReceiptNumber,
              'NA'
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Transporter Name
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(POBatchRecordDetails?.transporterName, 'NA')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}></Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Invoice Number
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(invoiceInformation?.invoiceNumber, 'NA')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Invoice Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {invoiceInformation?.invoiceDate
              ? presentFormatedData(
                  new Date(invoiceInformation?.invoiceDate.split('T')[0])
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}></Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Challan Number
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(challanInformation?.challanNumber, 'NA')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Challan Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {challanInformation?.challanDate
              ? presentFormatedData(
                  new Date(challanInformation?.challanDate.split('T')[0])
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}></Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Vehicle Number (Supplier)
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(asnDetails?.vehicleNumberSupplier, 'NA')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Vehicle Number (CMO)
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(challanInformation?.vehicleNumberCMO, 'NA')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}></Grid>

        <Grid item xs={12} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            CoA
          </Typography>
          {/* {asnDetails?.coaDocumentID ? (
            <Typography
              style={{
                color: 'blue',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              variant='body2'
              className={classes.fontPadding}
              // onClick={() => handleDownload(asnDetails?.coaDocumentID)}
              onClick={() => setOpenFileView(true)}
            >
              {coaName}
            </Typography>
          ) : (
            <Typography variant='body2' className={classes.fontPadding}>
              NA
            </Typography>
          )} */}
          {Array.isArray(asnDetails.COAFiles) &&
          asnDetails.COAFiles.length > 0 ? (
            asnDetails.COAFiles.map((val) => {
              return (
                <Typography
                  style={{
                    color: 'blue',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  variant='body2'
                  className={classes.fontPadding}
                  // onClick={() => handleDownload(asnDetails?.coaDocumentID)}
                  onClick={() => {
                    setCoAId(val.schrockenGRFileId);
                    setOpenFileView(true);
                  }}
                >
                  {val.grFileName}
                </Typography>
              );
            })
          ) : (
            <Typography variant='body2' className={classes.fontPadding}>
              NA
            </Typography>
          )}
        </Grid>
        <FileViewer
          fileId={coaId}
          openFileView={openFileView}
          handleFileViewClose={() => setOpenFileView(false)}
          downloadFile={handleDownload}
        />
      </Grid>
    </React.Fragment>
  );
};

export default ASNDetails;
